export default __webpack_public_path__ + "static/1-4e54b8a87b0f996d24cfd8b7903f14b0.png";